import { Injectable } from "@nestjs/common";
import { EntityRepository, Repository } from "typeorm";
import { AttendanceLogEntity } from "../entities/attendance-log.entity";
import { EmployeeAttendanceQueryResponse } from "./emp-attn.query.response";

@Injectable()
@EntityRepository(AttendanceLogEntity)
export class AttendanceLogRepository extends Repository<AttendanceLogEntity> {

    constructor() {
        super();
    }

    async getAttendanceLog(date: string): Promise<EmployeeAttendanceQueryResponse[]> {
        const query = this.createQueryBuilder('attendance_log')
            .select(` employee_code, log_date, device_code, download_date, verify_mode`)
            .where(` DATE(log_date) = '${date}' `)
            .orderBy(` employee_code, log_date`)
        return await query.getRawMany();
    }

    async getNonProcessedAttendanceLogs(): Promise<EmployeeAttendanceQueryResponse[]> {
        const query = this.createQueryBuilder('attendance_log')
            .select(`attendace_log_id, employee_code, employee_name, log_date, device_code, download_date, direction, verify_mode, date(log_date) as log_only_date`)
            .where(`status = false `)
            .orderBy(` employee_code, log_date`)
        return await query.getRawMany();
    }

}